import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {}
}

export default createCrudModule({
  client: api.client,
  resource: 'bookedTasks',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn: (id, params) => {
    const prefix = `/projects/${params.project_id}`;
    const suffix = `/booked_tasks${id ? '/'+id : ''}`;
    if ( params.invoice_id && params.booking_id ) {
      return prefix + `/invoices/${params.invoice_id}/bookings/${params.booking_id}` + suffix;
    } else {
      return prefix + suffix;
    }
  },
  state
});